import React from 'react'
import { object, arrayOf } from 'prop-types'
import withSend from 'microcosm/addons/with-send'
import Select from 'lib/components/select'
import PatchLink from 'lib/components/patch-link'
import Icon from 'lib/components/icon'
import RA from 'ra-config'
import { within, without } from '../../../selection'
import { getColor } from '../../../config/colors'

const LIMIT = 6

class SidebarHistorical extends React.PureComponent {
  static propTypes = {
    query: object,
    strategies: arrayOf(object)
  }

  renderCategory(category) {
    const { strategies, query } = this.props

    const itemsForCategory = strategies.filter(
      ({ Category }) => Category === category.name
    )
    const color = getColor(category.name)

    const nextQuery = {
      category: category.name,
      selected: itemsForCategory.map(i => i.Key)
    }

    if (within(query.selected, nextQuery.selected)) {
      nextQuery.selected = without(this.props.selected, query.selected)
    }

    return (
      <li key={`sidebar-category-${category.name}`} style={{ color }}>
        <div className="sidebar-list-category">
          <PatchLink
            query={nextQuery}
            trackAs="sidebar-category"
            track={category.name}
          >
            <svg className="sidebar-list-key">
              <circle fill={color} r="6" cx="6" cy="6" />
            </svg>

            <h3 className="type-title">{category.name}</h3>
          </PatchLink>

          <PatchLink
            query={{ category: undefined, selected: undefined }}
            className="sidebar-list-close"
          >
            <Icon type="close" height="20px" width="20px" />
            <span className="screenreader-only">Clear Filter</span>
          </PatchLink>
        </div>

        <ul>{itemsForCategory.map(i => this.renderCategoryItem(i))}</ul>
      </li>
    )
  }

  renderCategoryItem(item) {
    const { query } = this.props

    const nextQuery = {
      category: undefined,
      selected: [].concat(item.Key, query.selected || []).slice(0, LIMIT)
    }

    if (item.isFocused) {
      nextQuery.selected = nextQuery.selected.filter(i => i !== item.Key)
    }

    return (
      <li key={item.Key}>
        <PatchLink
          query={nextQuery}
          className={item.isFocused ? 'active' : null}
          trackAs="sidebar-item"
          track={`Strategies: ${item.Name}`}
        >
          {item.Name} {item.loading ? '(Loading...)' : null}
        </PatchLink>
      </li>
    )
  }

  render() {
    const { topNavigation } = RA.app.page

    return (
      <aside className="sidebar">
        <div className="sidebar__main">
          <Select
            label="Select Equity Category"
            labelFor="location-filter"
            labelVisible={false}
            onChange={this.onSelectChange}
            options={topNavigation}
            selected="/strategies"
            selectedText="Strategies"
          />
          <ul className="sidebar-list">
            {RA.app.strategies.categoryList.map(this.renderCategory, this)}
          </ul>
        </div>
      </aside>
    )
  }

  onSelectChange = event => {
    event.target.blur()
    this.props.send('visit', event.target.value)
  }
}

export default withSend(SidebarHistorical)



// WEBPACK FOOTER //
// ./src/components/strategies/historical/sidebar.js